import React, { useState } from 'react'

import { MdSearch } from 'react-icons/md'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTheme } from 'styled-components'

import appBrand from '@assets/logo-white.png'
import { useNames } from '@hooks/names'

import {
  Brand,
  BrandContainer,
  BrandLabel,
  Container,
  HeaderItems,
  RouteName,
} from './styles'

export function TabHeader() {
  const location = useLocation()
  const navigate = useNavigate()
  const { splitAndCapitalize } = useNames()
  const routeName = location.pathname.replace('/', '') || 'home'
  const viewName = splitAndCapitalize(routeName)
  const [brandTaps, setBrandTaps] = useState<number>(0)

  const routes = ['week-view', 'todo', 'process', 'mechanical']
  const shouldShowSearch = routes.some((r) => location.pathname.includes(r))

  const theme = useTheme()

  function brandPress() {
    setBrandTaps((prevCount) => prevCount + 1)
    if (brandTaps > 4) {
      setBrandTaps(0)
    }
  }

  return (
    <Container>
      {shouldShowSearch ? (
        <HeaderItems>
          <BrandContainer onClick={brandPress}>
            <Brand src={appBrand} alt="DWS Logo" />
            <BrandLabel>Daily Work Schedule</BrandLabel>
          </BrandContainer>

          <button
            onClick={() => navigate('/search')}
            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
          >
            <MdSearch size={30} color={theme.colors.headerText} />
          </button>
        </HeaderItems>
      ) : (
        <RouteName>{viewName}</RouteName>
      )}
    </Container>
  )
}
